export default "__VITE_ASSET__jueeXPxC__"